/* Swatches */
function swatchChange(e) {
    var swatchContainer = e.parentNode.parentNode.parentNode.parentNode;
    var currentActiveCard = swatchContainer.querySelector('.snippet-product-item-2.active');
    var newActiveCard = swatchContainer.querySelector('[data-colour-index=\'' + e.getAttribute('data-index') + '\']');
    var activeBtn = newActiveCard.querySelector('[data-index=\'' + e.getAttribute('data-index') + '\']');

    currentActiveCard.classList.remove('active');
    newActiveCard.classList.add('active');
    activeBtn.classList.add('active');
}